import "core-js/features/map";
import "core-js/features/set";
import React from "react";
import { createRoot } from "react-dom/client";
import bridge from "@vkontakte/vk-bridge";
import * as Sentry from '@sentry/react';
import App from "./App";

// Init VK  Mini App
bridge.send("VKWebAppInit", {});

if (process.env.REACT_APP_SENTRY_KEY) {
  Sentry.init({
    dsn: `https://${process.env.REACT_APP_SENTRY_KEY}@o118021.ingest.sentry.io/5244731`,
    release: `${process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA}`,
    whitelistUrls: ["/https?://geo-puzzle-vk.now.sh/"],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [new Sentry.Replay({maskAllText: false, blockAllMedia: false})],
  });

}

const root = createRoot(document.getElementById("root"));
root.render(<App />);
